import React, { useState, useEffect } from 'react';
import { HiMenuAlt3 } from 'react-icons/hi';
import { NavLink, useLocation } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import AuthorizeUser from './AuthorizeUser';
import AuthorizeUserMobile from './AuthorizeUserMobile';
import NavBrand from './NavBrand';
import useAuth from '../../hooks/useAuth';

const Navbar = () => {
  const [changeHeader, setChangeHeader] = useState(false);
  const [mobileNav, setMobileNav] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  const baseMenu = [
    { id: 1, text: 'Accueil', to: '/' },
    { id: 2, text: 'Produits', to: '/products' },
    { id: 3, text: 'Contact', to: '/contact' },
  ];

  const fullMenu = [
    { id: 1, text: 'Accueil', to: '/' },
    { id: 2, text: 'Produits', to: '/products' },
    { id: 3, text: 'Commandes', to: '/historique-commandes' },
    { id: 4, text: 'Contact', to: '/contact' },
  ];

  const menu = user ? fullMenu : baseMenu;

  const handleClick = () => {
    setMobileNav(!mobileNav);
  };

  const onChangeHeader = () => {
    setChangeHeader(window.scrollY >= 50);
  };

  useEffect(() => {
    window.addEventListener('scroll', onChangeHeader);
    return () => window.removeEventListener('scroll', onChangeHeader);
  }, []);

  // Close mobile nav when location changes
  useEffect(() => {
    setMobileNav(false);
  }, [location.pathname]);

  return (
    <header className={changeHeader ? "bg-white fixed z-50 top-0 left-0 w-full shadow-md transition duration-500" : "bg-transparent fixed z-50 top-0 left-0 w-full transition duration-500"}>
      <nav className="flex items-center max-w-screen-xl mx-auto px-6 py-3">
        <div className="flex flex-grow">
          <NavBrand />
        </div>
        <div className="hidden md:flex lg:flex space-x-8">
          <ul className="flex items-center space-x-6">
            {menu.map(item => (
              <li key={item.id}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `text-paragaia text-lg poppins transition duration-300 ${
                      isActive ? 'border-b-4 border-paragaia text-paragaia underline' : 'hover:underline'
                    }`
                  }
                >
                  {item.text}
                </NavLink>
              </li>
            ))}
          </ul>
          <AuthorizeUser />
        </div>
        <div className="block md:hidden lg:hidden">
          <HiMenuAlt3
            className="w-10 h-10 text-paragaia border border-paragaia focus:ring-4 focus:ring-paragaia cursor-pointer rounded-lg p-2 transform transition duration-200 hover:scale-110"
            onClick={handleClick}
          />
        </div>
      </nav>
      {mobileNav && (
        <Fade>
          <nav className="bg-white shadow-lg mx-6 mt-2 p-4 rounded-lg border border-gray-300 py-4 block md:hidden lg:hidden">
            <ul className="mb-2">
              {menu.map(item => (
                <li key={item.id} className="mb-3">
                  <NavLink
                    to={item.to}
                    className={({ isActive }) =>
                      `text-paragaia poppins text-lg text-center py-2 px-3 w-full transition duration-300 block rounded-lg ${
                        isActive ? 'border-l-4 border-paragaia bg-paragaiaLight text-paragaia' : 'hover:bg-paragaiaLight hover:text-paragaia'
                      }`
                    }
                  >
                    {item.text}
                  </NavLink>
                </li>
              ))}
            </ul>
            <AuthorizeUserMobile />
          </nav>
        </Fade>
      )}
    </header>
  );
};

export default Navbar;
